import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import appConfig from './config/config';
import { configure } from '@nutrien/dxp-security-module';
import { parentOrchestrator } from './models/orchestrator/parentOrchestrator';
import * as serviceWorker from './service-worker';
import { resolveLoggingConfiguration } from './config/loggingConfig';
import * as Logging from '@nutrien/ddc-orchestrator-logging-legacy';

declare const SystemJS: any;
export let orchestrator: parentOrchestrator;

export async function Authenticate() {
  const loggingConfiguration = await resolveLoggingConfiguration();
  const logging = Logging.configure(loggingConfiguration);

  try {
    Logging.knock(logging);

    configure(appConfig.auth);
    setTimeout(async () => {
      orchestrator = new parentOrchestrator(SystemJS, logging);
      await orchestrator.authenticate();
    }, 1000);
  } catch (error) {
    logging.logError(error);
  }
}
export default Authenticate().catch(alert);
serviceWorker.register();
